const data = navigator.userAgentData?.platform || navigator.platform;

export const isMac = () => data.toLowerCase().includes('mac');

export const onIOS = () => ['iPad', 'iPhone', 'iPod'].includes(data);
